import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import Header from 'components/header';

export default class View extends Component {

  /* Render */

  render() {
    const {
      children,
      hasModalParent,
      tabs,
    } = this.props;

    const containerClassNames = classNames('view', { 'view--inside-modal': hasModalParent });
    const contentClassNames = classNames('view__content', { 'view__content--with-tabs': tabs && tabs.length });

    return (
      <div className={containerClassNames}>
        {this.renderHeader()}

        {this.renderTabs()}

        <div className={contentClassNames}>
          <div className="container">
            <div className="row">
              <div className="gr-12">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderHeader() {
    const {
      actions,
      backbutton,
      hasModalParent,
      loading,
      title,
    } = this.props;

    if (hasModalParent) return null;

    return (
      <div className="view__header">
        <Header
          actions={actions}
          backbutton={backbutton}
          title={title}
          loading={loading}
        />
      </div>
    );
  }

  renderTabs() {
    const { tabs } = this.props;

    if (!tabs || !tabs.length) {
      return null;
    }

    const content = tabs.map((tab) => {
      return (
        <div key={tab.id} className="align__cell align__cell--shrink">
          <Link to={tab.link} className="button view__tab" activeClassName="is-active">
            <FormattedMessage id={tab.title} />
          </Link>
        </div>
      );
    });

    return (
      <div className="view__tabs">
        <div className="container">
          <div className="row">
            <div className="gr-12">
              <div className="align align--fluid align--gutter-md">
                {content}
                <div className="align__cell" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

View.propTypes = {
  actions: PropTypes.node,
  backbutton: PropTypes.func,
  children: PropTypes.node,
  hasModalParent: PropTypes.bool,
  loading: PropTypes.bool,
  tabs: PropTypes.array,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/view/index.jsx